<template>
  <div class="container">
    <div class="nav-tab">
      <!-- <div style="display: flex">
          <img src="../../../assets/images/arrow.png" class="ims" alt="" />
          <div>您的当前位置是：首页-廉政消防</div>
        </div>
        <div
          class="hover-underline"
          style="display: flex; margin-right: 56px"
          @click="returnshow"
        >
          <div style="display: inline-block">
            <img src="../../../assets/images/return.png" class="imgs" alt="" />
          </div>
          返回
        </div> -->
      <div class="top">
        <div class="scrach">
          <input
            type="text"
            placeholder="请输入"
            v-model="searchValue"
            class="no-outline-input"
          />
          <div class="button" @click="getlistAll">
            <img src="../../../assets/images/search.png" alt="" />
          </div>
        </div>
      </div>
      <div class="serachItem">
        <div style="display: flex">
          <div style="width: 130px; height: 40px; line-height: 40px">
            结果分类：
          </div>
          <div style="display: flex; flex-flow: wrap">
            <div
              :class="[
                'items hover-underline',
                textactive == 99 ? 'textactive' : '',
              ]"
              @click="allList(99)"
            >
              全部(<span :class="total99 > 0 ? 'red' : ''">{{ total99 }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 0 ? 'textactive' : '',
              ]"
              @click="allList(0)"
            >
              消防要闻(<span :class="total0 > 0 ? 'red' : ''">{{ total0 }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 17 ? 'textactive' : '',
              ]"
              @click="allList(17)"
            >
              上级文件(<span :class="total17 > 0 ? 'red' : ''">{{
                total17
              }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 18 ? 'textactive' : '',
              ]"
              @click="allList(18)"
            >
              支队文件(<span :class="total18 > 0 ? 'red' : ''">{{
                total18
              }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 2 ? 'textactive' : '',
              ]"
              @click="allList(2)"
            >
              机关动态(<span :class="total2 > 0 ? 'red' : ''">{{ total2 }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 3 ? 'textactive' : '',
              ]"
              @click="allList(3)"
            >
              基层动态(<span :class="total3 > 0 ? 'red' : ''">{{ total3 }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 4 ? 'textactive' : '',
              ]"
              @click="allList(4)"
            >
              灾情速递(<span :class="total4 > 0 ? 'red' : ''">{{ total4 }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 5 ? 'textactive' : '',
              ]"
              @click="allList(5)"
            >
              媒体聚焦(<span :class="total5 > 0 ? 'red' : ''">{{ total5 }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 6 ? 'textactive' : '',
              ]"
              @click="allList(6)"
            >
              调研专题(<span :class="total6 > 0 ? 'red' : ''">{{ total6 }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 7 ? 'textactive' : '',
              ]"
              @click="allList(7)"
            >
              他山之石(<span :class="total7 > 0 ? 'red' : ''">{{ total7 }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 9 ? 'textactive' : '',
              ]"
              @click="allList(9)"
            >
              工作简报(<span :class="total9 > 0 ? 'red' : ''">{{ total9 }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 10 ? 'textactive' : '',
              ]"
              @click="allList(10)"
            >
              工作计划(<span :class="total10 > 0 ? 'red' : ''">{{
                total10
              }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 12 ? 'textactive' : '',
              ]"
              @click="allList(12)"
            >
              会议纪要(<span :class="total12 > 0 ? 'red' : ''">{{
                total12
              }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 13 ? 'textactive' : '',
              ]"
              @click="allList(13)"
            >
              工作督办(<span :class="total13 > 0 ? 'red' : ''">{{
                total13
              }}</span
              >)
            </div>
            <div
              :class="[
                'items hover-underline',
                textactive == 16 ? 'textactive' : '',
              ]"
              @click="allList(16)"
            >
              通知栏(<span :class="total16 > 0 ? 'red' : ''">{{ total16 }}</span
              >)
            </div>
            <!-- <div
              :class="['items', textactive == 11 ? 'textactive' : '']"
              @click="allList(11)"
            >
              专项工作(<span :class="total11>0?'red':''">{{ total11 }}</span>)
            </div> -->
          </div>
        </div>
        <div style="display: flex">
          <div style="width: 100px; height: 40px; line-height: 40px">
            时间范围：
          </div>
          <div style="display: flex; flex-flow: row wrap">
            <div
              style="margin-left: 6px"
              :class="[
                'items hover-underline',
                timeactive == 0 ? 'textactive' : '',
              ]"
              @click="nonetime"
            >
              时间不限
            </div>
            <div
              :class="[
                'items hover-underline',
                timeactive == 1 ? 'textactive' : '',
              ]"
              @click="oneDay"
            >
              一天内
            </div>
            <div
              :class="[
                'items hover-underline',
                timeactive == 2 ? 'textactive' : '',
              ]"
              @click="sevenDay"
            >
              一周内
            </div>
            <div
              :class="[
                'items hover-underline',
                timeactive == 3 ? 'textactive' : '',
              ]"
              @click="threethDay"
            >
              一个月内
            </div>
            <div
              :class="['items', timeactive == 4 ? 'textactive' : '']"
              style="display: flex"
            >
              <div style="margin-right: 10px">指定时间范围</div>
              <div>
                <el-date-picker
                  style="height: 40px"
                  v-model="value1"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
              <div class="hover-underline chax" @click="searchTime">搜索</div>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div style="width: 100px; height: 40px; line-height: 40px">
            查询内容：
          </div>
          <div style="padding: 10px 0 0 8px">
            <el-radio-group v-model="radio" @change="searchContent">
              <el-radio :label="0">标题</el-radio>
              <el-radio :label="1">作者</el-radio>
              <el-radio :label="2">出处</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div>
        搜索<span class="red">{{ searchValue }}</span
        >，共<span class="red">{{ total }}</span
        >条结果
      </div>
      <div class="serachItem" v-for="(item, index) in featureList" :key="index">
        <div class="dispFlex">
          <div class="title" v-if="item.messageType != null">
            <div>
              【{{
                infoTypeList.find((items) => items.value == item.messageType)
                  .label
              }}】
            </div>
          </div>
          <div class="contenttitle hover-underline" @click="goInfo(item)">
            {{ item.messageName }}
          </div>
        </div>
        <!-- <div class="content-box">
          <div class="content-box-item" v-html="item.messageContent"></div>
        </div> -->
        <div class="time">
          <span>作者：<span style="width: 160px;display: inline-block;">{{ item.author }}</span></span
          ><span>出处：<span style="width: 160px;display: inline-block;">{{ item.source }}</span></span
          ><span>发布时间：{{ item.releaseTime }}</span>
        </div>
      </div>
      <div style="margin-top: 20px">
        <el-pagination
          @size-change="sizeChange"
          @current-change="numChange"
          :page-sizes="[10, 20, 30, 40]"
          :current-page="searchFrom.pageNum"
          :page-size="searchFrom.pageSize"
          layout="->,total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { listspecial } from "@/api/index";
import { listAll } from "../../../api/index";
import { del } from "vue";
export default {
  name: "ImportantNews",
  props: ["searchValue"],
  data() {
    return {
      list: [
        "活动要闻",
        "上级精神",
        "机关文件",
        "信息动态",
        "活动风采",
        "典型风采",
        "党史资料",
        "简报专刊",
        "推荐阅读",
      ],
      total: 0,
      radio: 0,
      selectedItem: "活动要闻",
      featureList: [], // 消防要闻
      searchFrom: {
        pageNum: 1,
        pageSize: 10,
        status: 4,
        messageName: this.searchValue,
      },
      infoTypeList: [
        { label: "消防要闻", value: 0 },
        { label: "上级文件", value: 17 },
        { label: "支队文件", value: 18 },
        { label: "机关动态", value: 2 },
        { label: "基层动态", value: 3 },
        { label: "灾情速递", value: 4 },
        { label: "媒体聚焦", value: 5 },
        { label: "调研专题", value: 6 },
        { label: "他山之石", value: 7 },
        { label: "专题专栏", value: 8 },
        { label: "工作简报", value: 9 },
        { label: "工作计划", value: 10 },
        { label: "专项工作", value: 11 },
        { label: "会议纪要", value: 12 },
        { label: "工作督办", value: 13 },
        { label: "轮播图", value: 14 },
        { label: "banner图", value: 15 },
        { label: "通知栏", value: 16 },
      ],
      startDate: "",
      endDate: "",
      textactive: 99,
      timeactive: 0,
      allList16: [],
      messageTypeCounts: [],
      total0: 0,
      total1: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      total5: 0,
      total6: 0,
      total7: 0,
      total8: 0,
      total9: 0,
      total10: 0,
      total11: 0,
      total12: 0,
      total13: 0,
      total16: 0,
      total17: 0,
      total18: 0,
      total99: 0,
      messageType: "",
      value1: [],
    };
  },
  mounted() {
    this.getlistAll();
  },
  methods: {
    searchContent(val) {
      console.log(val);
      if (val == 0) {
        delete this.searchFrom.author;
        delete this.searchFrom.source;
        this.searchFrom.messageName = this.searchValue;
        this.getlistAll();
      } else if (val == 1) {
        delete this.searchFrom.messageName;
        delete this.searchFrom.source;
        this.searchFrom.author = this.searchValue;
        this.getlistAll();
      } else {
        delete this.searchFrom.messageName;
        delete this.searchFrom.author;
        this.searchFrom.source = this.searchValue;
        this.getlistAll();
      }
    },
    searchTime() {
      console.log(this.value1);
      this.searchFrom.startDate = this.value1[0];
      this.searchFrom.endDate = this.value1[1];
      this.getlistAll();
    },
    goInfo(item) {
      // 使用window.open方法在新窗口或选项卡中打开链接
      const ids = item.id;
      let url = `/?ids=${encodeURIComponent(ids)}`;
      if (item.fileUrl) {
        url = item.fileUrl;
      }
      window.open(url, "_blank");
    },
    formatDate(date) {
      return date.toISOString().split("T")[0].trim(); // 格式化为 YYYY-MM-DD
    },
    getlistAll() {
      listAll({
        ...this.searchFrom,
        messageType: this.messageType,
      }).then((res) => {
        this.featureList = res.data.data.list;
        this.total = res.data.data.total;
      });
      this.getlistAlltotal();
    },

    nonetime() {
      this.searchFrom.startDate = "";
      this.searchFrom.endDate = "";
      this.timeactive = 0;
      this.getlistAll();
      this.value1 = [];
    },
    oneDay() {
      this.timeactive = 1;
      this.getCurrentDate();
      this.getPreviousDay();
    },
    sevenDay() {
      this.timeactive = 2;
      this.getCurrentDate();
      this.getLastWeek();
    },
    threethDay() {
      this.timeactive = 3;
      this.getCurrentDate();
      this.getLastMonth();
    },
    formatDate(date) {
      return date.toISOString().split("T")[0]; // 格式化为 YYYY-MM-DD
    },
    getCurrentDate() {
      const currentDate = new Date();
      this.searchFrom.endDate = this.formatDate(currentDate);
    },
    getPreviousDay() {
      const previousDay = new Date();
      previousDay.setDate(previousDay.getDate() - 1);
      this.searchFrom.startDate = this.formatDate(previousDay);
      this.value1 = [];
      this.getlistAll();
    },
    getLastWeek() {
      const lastWeek = new Date();
      lastWeek.setDate(lastWeek.getDate() - 7);
      this.searchFrom.startDate = this.formatDate(lastWeek);
      console.log(this.searchFrom.endDate);
      this.value1 = [];
      this.getlistAll();
    },
    // 月份
    getLastMonth() {
      const lastMonth = new Date();
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      this.searchFrom.startDate = this.formatDate(lastMonth);
      console.log(this.searchFrom.endDate);
      this.value1 = [];
      this.getlistAll();
    },
    allList(active) {
      this.textactive = active;
      this.messageType = active;
      if (this.messageType == 99) {
        this.messageType = "";
      }
      this.value1 = [];
      this.getlistAll();
    },
    // 分页器
    numChange(page) {
      this.searchFrom.pageNum = page;
      this.value1 = [];
      this.getlistAll();
    },
    sizeChange(val) {
      this.searchFrom.pageSize = val;
      this.value1 = [];
      this.getlistAll();
    },

    getlistAlltotal() {
      listAll({
        ...this.searchFrom,
      }).then((res) => {
        this.total99 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 0,
      }).then((res) => {
        this.total0 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 1,
      }).then((res) => {
        this.total1 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 2,
      }).then((res) => {
        this.total2 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 3,
      }).then((res) => {
        this.total3 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 4,
      }).then((res) => {
        this.total4 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 5,
      }).then((res) => {
        this.total5 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 6,
      }).then((res) => {
        this.total6 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 7,
      }).then((res) => {
        this.total7 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 8,
      }).then((res) => {
        this.total8 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 9,
      }).then((res) => {
        this.total9 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 10,
      }).then((res) => {
        this.total10 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 11,
      }).then((res) => {
        this.total11 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 17,
      }).then((res) => {
        this.total17 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 18,
      }).then((res) => {
        this.total18 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 12,
      }).then((res) => {
        this.total12 = res.data.data.total;
      });
      listAll({
        ...this.searchFrom,
        messageType: 13,
      }).then((res) => {
        this.total13 = res.data.data.total;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  background: #f0f5ff;
}
.chax {
  margin-left: 8px;
  text-align: center;
  line-height: 26px;
  margin-top: 7px;
  color: #fff;
  width: 48px;
  height: 28px;
  background: #2b56ac;
  border-radius: 0px 0px 0px 0px;
}
.dispFlex {
  width: 1080px;
  flex: 1; /* 使子项平分可用空间 */
  min-width: 0; /* 允许子项缩小到 0 */
  display: flex;
  flex-flow: row nowrap;
}
.textactive {
  font-weight: bold;
  color: #2b56ac;
}
.nav-tab {
  width: 1080px;
  background: #f5f5f5;

  margin: 0 auto;
  padding: 40px 20px 20px 20px;
  .serachItem {
    .items {
      margin-left: 22px;
      height: 40px;
      line-height: 40px;
    }
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
  }
  .scrach {
    width: 100%;
    display: flex;
    justify-content: center;

    .no-outline-input {
      width: 560px;
      height: 40px;
    }

    .button {
      width: 40px;
      height: 44px;
      background: #2b56ac;
      border-radius: 0 4px 4px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 18px;
        height: 20px;
      }
    }
  }
}
.content {
  width: 1080px;
  background-color: #fff;
  margin: 0 auto;
  padding: 20px;
  .serachItem {
    margin: 20px 0;
    .content-box {
      margin: 16px 0;
    }
    .content-box-item {
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .title {
      text-align: center;
      height: 30px;
      line-height: 30px;
      width: 96px;
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
      background-color: #355dac;
    }
    .contenttitle {
      overflow: hidden; /* 隐藏溢出的内容 */
      white-space: nowrap; /* 不换行 */
      text-overflow: ellipsis; /* 溢出时使用省略号 */
      padding: 6px;
      font-weight: 600;
      font-size: 14px;
      color: #333333;
    }
    .time {
      font-weight: 400;
      font-size: 14px;
      color: #c1c5cd;
    }
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}
.red {
  color: #e71111;
}
</style>
